export const otpCode = {
  validated: "Your code has been successfully verified.",
  resent: "The verification code has been resent to your email account."
};
